import type { IFirstTouchUtm } from "~/feature/attribution/type";
import { UtmParam } from "~/types/utm";

const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const FIRST_TOUCH_COOKIE = "ph_first_touch";
export const FIRST_TOUCH_TTL_DAYS = 30;
export const FIRST_TOUCH_TTL_MS = FIRST_TOUCH_TTL_DAYS * DAY_IN_MS;

export const UTM_FIELD_BY_PARAM: Record<UtmParam, keyof IFirstTouchUtm> = {
  [UtmParam.Source]: "utmSource",
  [UtmParam.Medium]: "utmMedium",
  [UtmParam.Campaign]: "utmCampaign",
  [UtmParam.Content]: "utmContent",
};

export const GOOGLE_SIGN_IN_HOST = "accounts.google.com";
export const CLERK_HOSTED_DOMAIN = "accounts.dev";
